import type { Dispatch } from '@reduxjs/toolkit'

import { ingestApi } from '../ingest/ingest-api'

/** Refetch branch-scoped session paint (modifications + changeset folds). */
export function invalidateBranchIngestPaint(dispatch: Dispatch, branchId?: string): void {
  if (branchId) {
    dispatch(ingestApi.util.invalidateTags([{ type: 'BranchIngestPaint', id: branchId }]))
    return
  }
  dispatch(ingestApi.util.invalidateTags(['BranchIngestPaint']))
}
